import View from './view'
import compose from 'recompose/compose'
import {connect} from 'react-redux'
import {withRouter} from 'react-router'
import {withI18n} from '../../hocs'
import {
  actions as ProfileExitInterviewActions,
  operations as ProfileExitInterviewOperations
} from '../../../redux/profileExitInterview'
import { ExitInterviewOperations } from '../../../redux/exitInterview'
import {ProcessesActions} from "../../../redux/processes";

const mapStateToProps = state => ({
  data: state.profileExitInterview.data,
  isFetching: state.profileExitInterview.isFetching,
  statusTypes: state.profileExitInterview.statusTypes,
  dataInboxRows: state.processes.dataInbox,
  tablePage: state.processes.page,
  tablePerPage: state.processes.perPage,
})

const mapDispatchToProps = dispatch => {
  return {
    setData: data => dispatch(ProfileExitInterviewActions.setData(data)),
    changeStatus: (id, status, module) => dispatch(ProfileExitInterviewOperations.changeStatus(id, status, module)),
    addFav: (id, isFAv, module) => dispatch(ProfileExitInterviewOperations.addFav(id, isFAv, module)),
    fetchStatusTypes: (module) => dispatch(ExitInterviewOperations.fetchStatusTypes(module)),
    deleteProcess: (id, module) => dispatch(ProfileExitInterviewOperations.deleteProcess(id, module)),
    tableSetPage: ( page ) => dispatch(ProcessesActions.setPage(page)),
  }
}

const enharce = compose(connect(mapStateToProps, mapDispatchToProps), withRouter, withI18n)

export default enharce(View)
